import { env } from '@hb/mbridge';
import envConfig, { APP_ENV_ENUM } from './envConfig';

let appEnv = (process.env.VUE_APP_ENV || 'fat') as APP_ENV_ENUM;

export function getAppEnv() {
  return appEnv;
}

const AppEnvAlias: Partial<Record<APP_ENV_ENUM, string>> = {
  dev: 'fat',
};

export function getStandardAppEnv(): string {
  return AppEnvAlias[appEnv] || appEnv;
}

/**
 * 模拟环境数据类型
 */
export type MockEnvData = {
  token: string
}
/**
 * 模拟环境数据
 */
let mockEnvData: MockEnvData | null = null;
export function getMockEnvData(): MockEnvData | null {
  return mockEnvData;
}

export function getCurEnvData() {
  return envConfig[appEnv];
}

export const { isAliMP, isIOS, isAndroid } = env;
export const { isAlipayBrowser } = env;
export const isAli = isAliMP || isAlipayBrowser || env.isAliMPMonitor;
export const isWeixin = env.isWeixin || env.isWechatMini;
export const { isEasyBikeApp, isWechatMini } = env;
/** 是否为已知哈啰大家庭APP */
export const { isHelloFamilyApp } = env;
export const { isHelloRentApp } = env;

/** 是否为交通银行小程序 */
export const isBoComTinyApp = navigator.userAgent.indexOf('BCMTinyApp') > -1;

export function setMockEnv(mockEnv: APP_ENV_ENUM, mock: MockEnvData) {
  if (!mockEnv) {
    return;
  }
  if (mockEnv in APP_ENV_ENUM) {
    mockEnvData = mock;
    appEnv = mockEnv;
  }
}

export function forceSetEnv(setEnv: APP_ENV_ENUM) {
  appEnv = setEnv;
}
type ExtendedEnv = typeof env & {
  isHarmony: boolean;
  isTTMP: boolean;
}
const extendedEnv = env as ExtendedEnv;
/** 获取systemCode http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=57034434 */
export function getSystemCode() {
  if (extendedEnv.isHarmony && isEasyBikeApp) {
    return '68';
  }
  if (extendedEnv.isTTMP) {
    return '69';
  }
  if (isHelloFamilyApp) {
    if (isAndroid) {
      if (isEasyBikeApp) {
        return '62';
      }
      if (env.isHelloRentApp) {
        return 'Hr2';
      }
      if (env.isHelloHitchApp) {
        return 'sfc2';
      }

      if (env.isRoverApp) {
        return 'Vp2';
      }
    } else {
      if (isEasyBikeApp) {
        return '61';
      }
      if (env.isHelloRentApp) {
        return 'Hr1';
      }

      if (env.isHelloHitchApp) {
        return 'sfc1';
      }
      if (env.isRoverApp) {
        return 'Vp1';
      }
    }
  } else if (env.isAliMP || env.isAlipayBrowser) {
    return '65';
  } else if (env.isWechatMini) {
    return '64';
  }
  const u = navigator.userAgent;
  const isBoc = u.indexOf('bocapp(') > -1;
  // 中国银行 app
  if (isBoc) {
    return 'l3';
  }
  // 交通银行小程序
  if (isBoComTinyApp) {
    return 'J1';
  }

  return '63';
}

export default {};
